<template>
  <div :class="$style.wrapper">
    <base-tooltip
      placement="bottom-end"
      :disabled="!tooltipEnabled"
    >
      <template #default="{ trigger }">
        <button
          :ref="trigger"
          :class="$style.button"
          type="button"
          @click.stop="$emit('click')"
        >
          <base-icon
            :type="icon"
            width="16px"
          />
        </button>
      </template>
      <template #content>
        <slot name="tooltip" />
      </template>
    </base-tooltip>
  </div>
</template>

<script>
import BaseIcon from '@/shared/legacy/ui/base-icon/icon.vue';
import BaseTooltip from '@/shared/legacy/ui/base-tooltip/base-tooltip.vue';

export default {
  name: 'ActionButton',
  components: {
    BaseTooltip,
    BaseIcon
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    tooltipEnabled: {
      type: Boolean,
      default: true
    }
  },
  emits: ['click']
};
</script>

<style module>
.button {
  @mixin reset-button-styles;
  display: inline-flex;
  padding: 13px 8px;
  color: #757575;
  cursor: pointer;
  margin: -9px 0;
}
</style>

<i18n lang="json">{}</i18n>
